import { useTheme as useMuiTheme } from "@mui/material";

const useTheme = () => {
    return useMuiTheme();
}

export default useTheme;